export const communityEventRequestConfig = (eventId: string) => ({
  urlBackendPath: "/community_events/{encoded_event_occurrence_id}" as const,
  params: { path: { encoded_event_occurrence_id: eventId } },
});
